import { render, staticRenderFns } from "./KebijakanPrivasi.vue?vue&type=template&id=7b43f9c2&"
import script from "./KebijakanPrivasi.vue?vue&type=script&lang=js&"
export * from "./KebijakanPrivasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports